<template>
  <div class="bis-wrap">
    <div class="bis-selected" v-if="items.length">
      <table class="bis-table">
        <thead>
        <tr>
          <th style="width:48px;">تصویر</th>
          <th>نام محصول</th>
          <th style="width:140px;">SKU</th>
          <th style="width:80px;">موجودی</th>
          <th style="width:110px;">تعداد در پکیج</th>
          <th style="width:60px;"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in items" :key="row.product_id">
          <td><img v-if="row.product && row.product.image" class="bis-thumb" :src="img_source(row.product.image)" alt=""></td>
          <td class="bis-name">{{ row.product ? row.product.name : row.product_id }}</td>
          <td class="bis-code">{{ row.product ? (row.product.sixteen_digit_code || '—') : '—' }}</td>
          <td class="bis-center">{{ row.product && row.product.inventory_count != null ? row.product.inventory_count : '—' }}</td>
          <td>
            <input
                type="number"
                min="1"
                step="1"
                class="bis-qty-input"
                :disabled="disabled"
                :value="row.quantity"
                @input="updateQuantity(row.product_id, $event.target.value)"
            >
          </td>
          <td>
            <button class="bis-remove" :disabled="disabled" @click="removeItem(row.product_id)" title="حذف">×</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="bis-empty">هنوز محصولی به پکیج اضافه نشده</div>

    <button class="bis-btn bis-btn-primary bis-add-btn" :disabled="disabled" @click="openPicker">+ افزودن محصول</button>

    <div v-if="showPicker" ref="backdrop" class="bis-dialog-backdrop" @click.self="closePicker">
      <div class="bis-dialog" role="dialog" aria-modal="true">
        <div class="bis-dialog-header">
          <div class="bis-title">انتخاب محصولات پکیج</div>
          <button class="bis-close" @click="closePicker">×</button>
        </div>

        <div class="bis-filters">
          <input v-model="filters.search_value" class="bis-input" type="text" placeholder="نام" @keyup.enter="applyFilters">
          <input v-model="filters.sku" class="bis-input" type="text" placeholder="GTIN / SKU" @keyup.enter="applyFilters">
          <select v-model="filters.category_tree" class="bis-input" @change="applyFilters">
            <option value="">همه دسته‌ها</option>
            <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
          </select>
          <input v-model.number="filters.min_inventory" class="bis-input" type="number" placeholder="حداقل موجودی" @keyup.enter="applyFilters">
          <brand-select v-model="filters.brand_in" class="bis-input" @change="applyFilters"></brand-select>

          <button class="bis-btn bis-btn-primary" @click="applyFilters">اعمال فیلتر</button>
          <button class="bis-btn" @click="resetFilters">پاک‌سازی</button>
        </div>

        <div class="bis-table-wrap">
          <table class="bis-table">
            <thead>
            <tr>
              <th style="width:56px;">تصویر</th>
              <th>نام محصول</th>
              <th style="width:160px;">SKU</th>
              <th style="width:90px;">وضعیت</th>
              <th style="width:80px;">موجودی</th>
              <th style="width:110px;">افزودن</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loadingList"><td colspan="6" class="bis-center">در حال بارگذاری...</td></tr>
            <tr v-else-if="productsList.length === 0"><td colspan="6" class="bis-center bis-muted">محصولی یافت نشد</td></tr>
            <tr
                v-for="p in productsList"
                :key="p.id"
                class="bis-row"
                :class="{ 'bis-row-disabled': isOutOfStock(p) || !p.has_partner }"
            >
              <td><img v-if="p.image" class="bis-thumb" :src="img_source(p.image)" alt=""></td>
              <td class="bis-name">{{ p.name }}</td>
              <td class="bis-code">{{ p.sixteen_digit_code || '—' }}</td>
              <td>
                <span class="bis-stock-badge" :class="p.in_stock ? 'bis-stock-in' : 'bis-stock-out'">
                  {{ p.in_stock ? 'موجود' : 'ناموجود' }}
                </span>
                <span v-if="!p.has_partner" class="bis-stock-badge bis-stock-out" title="این محصول پارتنر ندارد و نمی‌تواند به پکیج اضافه شود">
                  بدون پارتنر
                </span>
              </td>
              <td class="bis-center">{{ p.inventory_count != null ? p.inventory_count : '—' }}</td>
              <td>
                <button
                    class="bis-btn bis-btn-primary"
                    :disabled="isOutOfStock(p) || !p.has_partner || isSelected(p.id)"
                    :title="!p.has_partner ? 'این محصول پارتنر ندارد' : ''"
                    @click="addItem(p)"
                >{{ isSelected(p.id) ? 'اضافه شد' : 'افزودن' }}</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="bis-pagination">
          <div class="bis-pageinfo">نمایش {{ offset + 1 }} تا {{ Math.min(offset + limit, total) }} از {{ total }}</div>
          <div class="bis-pager">
            <button class="bis-btn" :disabled="offset===0" @click="prevPage">قبلی</button>
            <button class="bis-btn" :disabled="offset + limit >= total" @click="nextPage">بعدی</button>
          </div>
        </div>

        <div class="bis-dialog-actions">
          <button class="bis-btn bis-btn-primary" @click="closePicker">پایان انتخاب</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrandSelect from "@/components/selects/BrandSelect";

export default {
  name: "BundleItemsSelect",
  components: { BrandSelect },
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      showPicker: false,
      loadingList: false,
      productsList: [],
      total: 0,
      limit: 10,
      offset: 0,
      filters: { search_value: "", sku: "", brand_in: "", category_tree: "", min_inventory: "" },
      categories: [],
      _movedToBody: false,
    };
  },
  computed: {
    items() {
      return this.value || [];
    },
  },
  created() {
    this.fetchCategories();
  },
  methods: {
    fetchCategories() {
      this.request({
        url: this.endpoint("api/rootCategories"),
        method: "get",
        success: (data) => { this.categories = data || []; },
      });
    },
    isOutOfStock(p) {
      if (p.in_stock === false) return true;
      return p.inventory_count != null && p.inventory_count < 1;
    },
    isSelected(productId) {
      return this.items.some((i) => String(i.product_id) === String(productId));
    },
    apiListParams() {
      const params = { limit: this.limit, offset: this.offset };
      if (this.filters.search_value) params.search_value = this.filters.search_value;
      if (this.filters.sku) params.sku = this.filters.sku;
      if (this.filters.brand_in) params.brand_in = this.filters.brand_in;
      if (this.filters.category_tree) params.category_tree = this.filters.category_tree;
      if (this.filters.min_inventory) params.min_inventory = this.filters.min_inventory;
      return params;
    },
    fetchProductsList() {
      this.loadingList = true;
      this.request({
        url: this.endpoint("product/adminSelectProducts"),
        method: "get",
        params: this.apiListParams(),
        success: (data) => {
          this.productsList = data.results || [];
          this.total = data.count || 0;
          this.loadingList = false;
        },
        error: () => { this.loadingList = false; },
      });
    },
    openPicker() {
      this.showPicker = true;
      this.offset = 0;
      this.fetchProductsList();
      this.$nextTick(() => {
        if (this.$refs.backdrop && !this._movedToBody) {
          document.body.appendChild(this.$refs.backdrop);
          this._movedToBody = true;
        }
      });
    },
    closePicker() { this.showPicker = false; this._movedToBody = false; },
    applyFilters() { this.offset = 0; this.fetchProductsList(); },
    resetFilters() {
      this.filters = { search_value: "", sku: "", brand_in: "", category_tree: "", min_inventory: "" };
      this.applyFilters();
    },
    prevPage() { if (this.offset === 0) return; this.offset = Math.max(0, this.offset - this.limit); this.fetchProductsList(); },
    nextPage() { if (this.offset + this.limit >= this.total) return; this.offset += this.limit; this.fetchProductsList(); },

    addItem(p) {
      if (this.isOutOfStock(p) || !p.has_partner || this.isSelected(p.id)) return;
      const next = [...this.items, { product_id: p.id, quantity: 1, product: p }];
      this.$emit("input", next);
    },
    removeItem(productId) {
      const next = this.items.filter((i) => String(i.product_id) !== String(productId));
      this.$emit("input", next);
    },
    updateQuantity(productId, rawValue) {
      let qty = parseInt(rawValue, 10);
      if (!Number.isFinite(qty) || qty < 1) qty = 1;
      const next = this.items.map((i) => String(i.product_id) === String(productId) ? { ...i, quantity: qty } : i);
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.bis-wrap { display: flex; flex-direction: column; gap: 8px; }
.bis-empty { padding: 12px; text-align: center; font-size: 12px; color: #9ca3af; background: #f9fafb; border-radius: 10px; border: 1px dashed #e5e7eb; }
.bis-thumb { width: 32px; height: 32px; border-radius: 6px; object-fit: cover; border: 1px solid #eee; }
.bis-name { font-size: 12px; font-weight: 600; color: #111827; }
.bis-code { font-size: 11px; color: #6b7280; }
.bis-center { text-align: center; }
.bis-muted { color: #94a3b8; }

.bis-table { width: 100%; border-collapse: collapse; }
.bis-table th, .bis-table td { border-bottom: 1px solid #f1f5f9; padding: 8px; text-align: right; font-size: 12px; }

.bis-qty-input { width: 70px; padding: 4px 6px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 12px; text-align: center; }
.bis-remove { border: none; background: #fee2e2; color: #b91c1c; border-radius: 6px; padding: 2px 8px; cursor: pointer; }

.bis-add-btn { align-self: flex-start; }
.bis-btn { border: 1px solid #e5e7eb; background: #fff; border-radius: 8px; padding: 6px 12px; font-size: 12px; cursor: pointer; }
.bis-btn-primary { background: #2563eb; color: #fff; border-color: #2563eb; }
.bis-btn:disabled { opacity: .5; cursor: not-allowed; }

.bis-dialog-backdrop { position: fixed; inset: 0; background: rgba(0,0,0,.35); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.bis-dialog { width: min(960px, 96vw); background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,.25); display: flex; flex-direction: column; }
.bis-dialog-header { display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; border-bottom: 1px solid #eee; background: #fafafa; }
.bis-title { font-weight: 700; font-size: 13px; }
.bis-close { border: none; background: transparent; font-size: 20px; line-height: 1; cursor: pointer; }

.bis-filters { display: flex; flex-wrap: wrap; gap: 6px; padding: 12px 14px; }
.bis-input { flex: 1 1 160px; border: 1px solid #e5e7eb; border-radius: 8px; padding: 6px 10px; min-width: 140px; font-size: 12px; }

.bis-table-wrap { overflow: auto; max-height: 50vh; }
.bis-row-disabled { opacity: .55; }
.bis-row-disabled .bis-name { color: #9ca3af; }
.bis-stock-badge { display: inline-block; padding: 2px 8px; border-radius: 999px; font-size: 11px; font-weight: 600; }
.bis-stock-in { background: #dcfce7; color: #15803d; }
.bis-stock-out { background: #fee2e2; color: #b91c1c; }

.bis-pagination { display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; border-top: 1px solid #f1f5f9; background: #fafafa; }
.bis-pageinfo { font-size: 12px; color: #6b7280; }
.bis-pager .bis-btn { margin-inline-start: 6px; }
.bis-dialog-actions { padding: 10px 14px; display: flex; justify-content: flex-end; }
</style>
